import { render } from "./ContributeCamera.vue?vue&type=template&id=e2be353c&scoped=true"
import script from "./ContributeCamera.vue?vue&type=script&lang=js"
export * from "./ContributeCamera.vue?vue&type=script&lang=js"

import "./ContributeCamera.vue?vue&type=style&index=0&id=e2be353c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-e2be353c"

export default script